import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc';


const InventoryListDumb = ({
  handleSearch,
  handleView,
  defaultValues,
  content,
  options,
  isLoaded,
  validPermission
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues("project");
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onView = (document) => {
    handleView(document);
  };

  const createActions = () => {
    const actions = [];

    if (validPermission(projectId, 'isVisible')) actions.push({
      label: t('documentationList.components.table.view'),
      icon: <VisibilityOutlinedIcon color="primary" />,
      handle: onView,
    });

    return actions;
  }

  const columns = [
    { label: t('common.components.table.col.name'), key: 'label' },
  ];

  const actions = createActions();

  return (
    <>
      <HeadlinePage
        title="documentationList.headline"
      />

      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        options={options}
        hideSearch={true}
      />

      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="documentationList.components.titleList"
          columns={columns}
          content={content}
          actions={actions}
          loading={isLoaded}
        />
      </Paper>
    </>
  )
}

export default withPermission(InventoryListDumb, "documentations");
